import toast from "react-hot-toast";
import Swal from "sweetalert2";

export const showSuccess = (msg) => toast.success(msg);
export const showError = (msg) => toast.error(msg);
export const showLoading = (msg) => toast.loading(msg);

const userBaseStyle = {
  background: "#E9F7EF", // soft success green background
  color: "#1E4620", // deep readable green text
  borderRadius: "14px",
  padding: "14px 18px",
  fontFamily: "Poppins, sans-serif",
  boxShadow: "0 10px 30px rgba(0,0,0,0.12)",
  border: "1px solid rgba(46, 204, 113, 0.35)", // green border
};

export const userSuccess = (msg) =>
  toast.success(msg, {
    style: {
      ...userBaseStyle,
      borderLeft: "5px solid #2ecc71", // strong success indicator
    },
    iconTheme: {
      primary: "#2ecc71", // success green icon
      secondary: "#F7BFAD", // subtle brand accent preserved
    },
  });

export const userError = (msg) =>
  toast.error(msg, {
    style: {
      ...userBaseStyle,
      background: "#FFE3DA",
      borderLeft: "5px solid #f0653a",
    },
    iconTheme: {
      primary: "#f0653a",
      secondary: "#FFE3DA",
    },
  });

export const userLoading = (msg) =>
  toast.loading(msg, {
    style: {
      ...userBaseStyle,
      background: "#FFF0EA",
      borderLeft: "5px solid #f0653a",
    },
    iconTheme: {
      primary: "#f0653a",
      secondary: "#FFF0EA",
    },
  });

export const confirmAction = async ({
  title = "Are you sure?",
  text = "",
  confirmText = "Confirm",
  cancelText = "Cancel",
  icon = "warning",
}) => {
  const result = await Swal.fire({
    title,
    text,
    icon,
    showCancelButton: true,
    confirmButtonText: confirmText,
    cancelButtonText: cancelText,
    reverseButtons: true,
    focusCancel: true,
    scrollbarPadding: false,
    buttonsStyling: false,
    customClass: {
      popup: "rounded-2xl",
      title: "text-lg font-semibold text-primaryTextColor",
      htmlContainer: "text-sm text-secondaryTextColor",
      confirmButton:
        "px-5 py-2.5 rounded-xl bg-primaryBtnColor text-white font-semibold mx-2",
      cancelButton:
        "px-5 py-2.5 rounded-xl bg-gray-100 text-gray-700 font-semibold mx-2",
    },
  });

  return result.isConfirmed;
};

export const userConfirmAction = async ({
  title = "Are you sure?",
  text = "",
  confirmText = "Yes",
  cancelText = "Cancel",
  icon = "warning",
}) => {
  const result = await Swal.fire({
    title,
    text,
    icon,

    showCancelButton: true,
    confirmButtonText: confirmText,
    cancelButtonText: cancelText,
    scrollbarPadding: false,
    reverseButtons: true,
    focusCancel: true,
    buttonsStyling: false,

    background: "#FFF7F4", // very soft apricot tint
    color: "#381700",

    iconColor: "#f0653a",

    customClass: {
      popup: "rounded-2xl px-2",
      title: "text-lg font-semibold text-primaryTextColor",
      htmlContainer: "text-sm text-secondaryTextColor leading-relaxed",

      confirmButton:
        "px-6 py-2.5 rounded-xl bg-[#f0653a] text-white font-semibold mx-2 hover:opacity-90",

      cancelButton:
        "px-6 py-2.5 rounded-xl bg-[#F7BFAD] text-[#381700] font-semibold mx-2 hover:opacity-90",
    },
  });

  return result.isConfirmed;
};
